import React from "react";
import RouteListManagement from "./_components/RouteListManagement";

const RouteManagement: React.FC = () => {
  return (
    <>
      <div className="p-4 space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl text-[#212121] "> Route Management</h1>
        </div>
        <RouteListManagement />
      </div>
    </>
  );
};

export default RouteManagement;
